import { render, staticRenderFns } from "./ItemCreate.vue?vue&type=template&id=dabd6938&scoped=true"
import script from "./ItemCreate.vue?vue&type=script&lang=js"
export * from "./ItemCreate.vue?vue&type=script&lang=js"
import style0 from "./ItemCreate.vue?vue&type=style&index=0&id=dabd6938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabd6938",
  null
  
)

export default component.exports